import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const SECTIONS = [
  { id: 'home', label: '— 01 HOME' },
  { id: 'about', label: '— 02 ABOUT' },
  { id: 'experience', label: '— 03 EXPERIENCE' },
  { id: 'education', label: '— 04 EDUCATION' },
  { id: 'techstack', label: '— 05 STACK' },
  { id: 'projects', label: '— 06 PROJECTS' },
  { id: 'services', label: '— 07 SERVICES' },
  { id: 'contact', label: '— 08 CONTACT' },
];

const StickyLabel = () => {
  const [activeSection, setActiveSection] = useState(SECTIONS[0].label);
  const labelRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          const section = SECTIONS.find((s) => s.id === sectionId);
          
          if (section && section.label !== activeSection) {
            const newLabel = section.label;
            
            if (labelRef.current) {
              gsap.to(labelRef.current, {
                opacity: 0,
                x: -10,
                duration: 0.2,
                ease: 'power2.in',
                onComplete: () => {
                  setActiveSection(newLabel);
                  gsap.fromTo(
                    labelRef.current,
                    { opacity: 0, x: 10 },
                    { opacity: 0.4, x: 0, duration: 0.3, ease: 'power2.out' }
                  );
                },
              });
            }
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    SECTIONS.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      SECTIONS.forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, [activeSection]);

  useEffect(() => {
    if (labelRef.current) {
      gsap.set(labelRef.current, { opacity: 0.4 });
    }
  }, []);

  return (
    <div
      className="fixed left-6 top-1/2 -translate-y-1/2 z-50 hidden md:block"
      style={{
        writingMode: 'vertical-rl',
        transform: 'translateY(-50%) rotate(180deg)',
      }}
    >
      <span
        ref={labelRef}
        style={{
          fontFamily: "'Space Mono', monospace",
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.2em',
          color: '#111',
          opacity: 0.4,
          textTransform: 'uppercase',
          userSelect: 'none',
        }}
      >
        {activeSection}
      </span>
    </div>
  );
};

export default StickyLabel;
